import React from 'react';
import style from './style.scss'
import newId from '../../utils/newid';
import Label from './Label';


const ElementID = (props) => {
    const {item, field} = props;
    const id = newId();
    return (
        <div className={style.typeText}>
            {
                (typeof item.label !== 'undefined') &&
                <Label
                    id={id}
                    parentClass
                    label={item.label}
                />}
            <input
                type="text"
                id={id}
                className={style.input}
                value={(typeof field !== "undefined") && field[item.item]}
                readOnly="readOnly"
            />
            {item.label&&item.label.second&&<span className={style.secondLabel}>{item.label.second}</span>}
        </div>
    )
}

export default ElementID;
